import React, { useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import music from '../assets/audio/earth.mp3';

const Box = styled.div`
  display: flex;
  cursor: pointer;
  position: fixed;
  left: 18rem; /* Appears after Resume button */
  top: 2.8rem;
  z-index: 10;

  /* Tablets */
  @media (max-width: 768px) {
    left: 10rem; /* Moves closer on tablets */
    top: 3rem;
    transform: scale(0.9);
  }

  /* Mobile screens */
  @media (max-width: 480px) {
    left: 8rem; /* Takes Resume button's place */
    top: 5.5rem;
    transform: scale(0.8);
  }

  /* Small mobile screens */
  @media (max-width: 320px) {
    transform: scale(0.7);
    left: 7rem;
  }

  & > *:nth-child(1) {
    animation-delay: 0.2s;
  }
  & > *:nth-child(2) {
    animation-delay: 0.3s;
  }
  & > *:nth-child(3) {
    animation-delay: 0.4s;
  }
  & > *:nth-child(4) {
    animation-delay: 0.5s;
  }
  & > *:nth-child(5) {
    animation-delay: 0.8s;
  }
`;

const play = keyframes`
  0% { transform: scaleY(1); }
  50% { transform: scaleY(2); }
  100% { transform: scaleY(1); }
`;

const Line = styled.span`
  background: ${(props) => props.theme.text};
  border: 1px solid ${(props) => props.theme.body};
  animation: ${play} 1s ease infinite;
  animation-play-state: ${(props) => (props.click ? 'running' : 'paused')};
  height: 1.2rem;
  width: 3px;
  margin: 0 0.15rem;

  @media (max-width: 1440px) {
    height: 1.2rem;
    width: 3px;
  }

  @media (max-width: 1024px) {
    height: 1.1rem;
    width: 2.8px;
  }

  @media (max-width: 768px) {
    height: 1rem;
    width: 2.5px;
    margin: 0 0.12rem;
  }

  @media (max-width: 480px) {
    height: 1.2rem;
    width: 2.5px;
    margin: 0 0.1rem;
  }

  @media (max-width: 320px) {
    height: 1.2rem;
    width: 2.3px;
    margin: 0 0.08rem;
  }
`;

const SoundBar = () => {
  const ref = useRef(null);
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);

    if (!click) {
      ref.current.play();
    } else {
      ref.current.pause();
    }
  };

  return (
    <Box onClick={() => handleClick()}>
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />
      <audio src={music} ref={ref} loop />
    </Box>
  );
};

export default SoundBar;
